import React, { useState } from 'react';
import { Badge, IconButton } from '@mui/material';
import { Notifications as NotificationsIcon } from '@mui/icons-material';
import { ROLES } from '../../config/constants';
import { useNotifications } from '../../hooks/useNotifications';
import NotificationDropdown from './NotificationDropdown';

const NotificationBell = ({ roles = [] }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const isOrganizer = roles.includes(ROLES.ORGANIZER);

    const {
        notifications,
        unreadCount,
        loading,
        fetchNotifications,
        markAsRead,
    } = useNotifications({ perPage: 10, autoFetchList: false });

    if (!isOrganizer) {
        return null;
    }

    const handleOpen = (event) => {
        setAnchorEl(event.currentTarget);
        fetchNotifications();
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <IconButton
                onClick={handleOpen}
                className="relative p-2 sm:p-3 bg-white/95 border border-gray-200 shadow-sm text-primary rounded-full hover:bg-white hover:border-primary/30 transition-all duration-300"
                aria-label="Notifications"
            >
                <Badge
                    badgeContent={unreadCount}
                    color="error"
                    invisible={unreadCount === 0}
                    max={99}
                    sx={{
                        '& .MuiBadge-badge': {
                            fontSize: '0.65rem',
                            minWidth: 18,
                            height: 18,
                        },
                    }}
                >
                    <NotificationsIcon className="text-primary" fontSize="small" />
                </Badge>
            </IconButton>
            <NotificationDropdown
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                notifications={notifications}
                loading={loading}
                onMarkAsRead={markAsRead}
            />
        </>
    );
};

export default NotificationBell;
